import { render, staticRenderFns } from "./IntegrateAi.vue?vue&type=template&id=7796daaf&scoped=true&"
import script from "./IntegrateAi.vue?vue&type=script&lang=js&"
export * from "./IntegrateAi.vue?vue&type=script&lang=js&"
import style0 from "./IntegrateAi.vue?vue&type=style&index=0&id=7796daaf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796daaf",
  null
  
)

export default component.exports